import axios from "axios";

const API_PATH = '/manage/message';

const FetchSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

const FetchSourceDetail = async ({ id }) => (
	await axios.get(`${API_PATH}/${id}`)
);

const CreateSingleMessage = async source => (
    await axios.post(API_PATH, source, {headers: { 'Content-Type': 'multipart/form-data' }})
)

const SettingSendMessageTime = async ({ id }) => (
	await axios.put(`${API_PATH}/setting/${id}`)
);

const FetchMessageSettingDropdown = async source => (
	await axios.get(`${API_PATH}/setting/dropdown`, source)
);

const FetchMessageSetting = async source => (
	await axios.get(`${API_PATH}/setting`, source)
);

const RemoveMessage = async id => (
	await axios.delete(`${API_PATH}/${id}`)
);

const MessageResend = async uId => (
	await axios.put(`${API_PATH}/${uId}/resend`)
);

const EditMessage= async ({ id, source }) => (
	await axios.put(`${API_PATH}/${id}`, source, {headers: { 'Content-Type': 'multipart/form-data' }})
);

export { FetchSource, FetchSourceDetail, CreateSingleMessage, SettingSendMessageTime, FetchMessageSetting, FetchMessageSettingDropdown, RemoveMessage, MessageResend, EditMessage } ;
